import { render, staticRenderFns } from "./TechProps.vue?vue&type=template&id=3411af3a&"
import script from "./TechProps.vue?vue&type=script&lang=js&"
export * from "./TechProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports